export default "__VITE_ASSET__BEbRvUV7__"